import { Box, Container, Grid, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";

const Services = ({ showButton }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#0d0d0d",
        borderBottom: "1px solid #1e1e1e",
        py: { xs: 5, md: 6 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtle gold glow */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "50%",
          height: "100%",
          background: "radial-gradient(ellipse at 80% 50%, rgba(255,192,1,0.06) 0%, transparent 65%)",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4} alignItems="center">
          {/* Left: text */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              {/* Label */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                <MiscellaneousServicesIcon sx={{ color: "#FFC001", fontSize: 18 }} />
                <Typography sx={{ color: "#FFC001", fontSize: "13px", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" }}>
                  Services
                </Typography>
              </Box>

              {/* Title */}
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: { xs: "28px", sm: "36px", md: "42px" },
                  lineHeight: 1.15,
                  mb: 2,
                }}
              >
                The Best{" "}
                <Box component="span" sx={{ color: "#FFC001" }}>Service</Box>
                <br />Ever
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  color: "#888",
                  fontSize: { xs: "14px", md: "15px" },
                  lineHeight: 1.8,
                  maxWidth: "480px",
                  mb: showButton ? 3 : 0,
                }}
              >
                We are committed to providing the best possible experience for all
                of our users. Whether you are looking for your next companion or
                utilizing our tools to help someone bring home their new family
                member — we make the journey as easy as possible.
              </Typography>

              {showButton && (
                <Button
                  component={Link}
                  to="/services"
                  sx={{
                    backgroundColor: "#FFC001",
                    color: "#000",
                    fontWeight: 700,
                    fontSize: "14px",
                    px: 3.5,
                    py: 1.2,
                    borderRadius: "24px",
                    textTransform: "none",
                    "&:hover": { backgroundColor: "#e6ac00" },
                  }}
                >
                  Browse Services
                </Button>
              )}
            </motion.div>
          </Grid>

          {/* Right: image */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
            >
              <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-end" } }}>
                <img
                  src="https://res.cloudinary.com/dwezij7u7/image/upload/v1674834891/Moore%20Exotics%20Assets/services/pets_qktwoj.png"
                  alt="Services"
                  style={{
                    width: "100%",
                    maxWidth: "420px",
                    filter: "drop-shadow(0 0 40px rgba(255,192,1,0.12))",
                  }}
                />
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
